import { __decorate, __extends, __metadata } from "tslib";
import React from 'react';
import { Components, ModalUtils } from '@singularsystems/neo-core';
import { Observer } from 'mobx-react';
import { makeObservable, observable } from 'mobx';
var ErrorGroup = /** @class */ (function () {
    function ErrorGroup(errorDisplay) {
        this.errorDisplay = errorDisplay;
        this.count = 1;
        makeObservable(this);
    }
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], ErrorGroup.prototype, "count", void 0);
    return ErrorGroup;
}());
var ErrorHandler = /** @class */ (function (_super) {
    __extends(ErrorHandler, _super);
    function ErrorHandler(notifications) {
        var _this = _super.call(this, notifications) || this;
        _this.errorList = [];
        _this.hidingErrorList = null;
        makeObservable(_this);
        return _this;
    }
    ErrorHandler.prototype.displayError = function (displayType, error, errorDisplay) {
        if (errorDisplay.data) {
            errorDisplay.body = React.createElement(React.Fragment, null,
                errorDisplay.body,
                React.createElement("ul", null,
                    errorDisplay.data.errors.map(function (err) { return (React.createElement("li", null, err)); }),
                    errorDisplay.data.properties.map(function (property) { return (React.createElement("li", null,
                        React.createElement("span", { "data-tip": "On field: " + property.key }, property.errors))); })));
        }
        _super.prototype.displayError.call(this, displayType, error, errorDisplay);
    };
    ErrorHandler.prototype.displayModal = function (error, errorDisplay) {
        var _this = this;
        if (errorDisplay.statusCode) {
            var existing = this.errorList.find(function (c) { return c.errorDisplay.statusCode === errorDisplay.statusCode; });
            if (existing) {
                existing.count += 1;
                return;
            }
        }
        var errorGroup = new ErrorGroup(errorDisplay);
        if (this.errorList.length === 0) {
            this.hidingErrorList = null;
            var modalOptions = errorDisplay.isServerError ? {
                footerContent: React.createElement("div", { className: "neo-error-modal-info" },
                    "Timestamp: ",
                    new Date().toISOString())
            } : {};
            modalOptions.onClose = function () {
                _this.hidingErrorList = _this.errorList;
                _this.errorList = [];
            };
            ModalUtils.showModal(errorDisplay.header, React.createElement(Observer, null, function () {
                var _a;
                return React.createElement(React.Fragment, null, ((_a = _this.hidingErrorList) !== null && _a !== void 0 ? _a : _this.errorList).map(function (errorGroup, index) { return (React.createElement("div", { key: index, className: "neo-error-modal-body" },
                    React.createElement("div", { className: "neo-error-modal-body-icon" }, errorGroup.count === 1 ?
                        React.createElement("i", { className: _this.getIcon(errorGroup.errorDisplay) }) :
                        React.createElement("span", { className: "badge badge-danger" }, errorGroup.count)),
                    React.createElement("div", null, errorGroup.errorDisplay.body))); }));
            }), modalOptions);
        }
        if (this.errorList.length < 5) {
            this.errorList.push(errorGroup);
        }
    };
    ErrorHandler.prototype.getIcon = function (errorDisplay) {
        if (errorDisplay.statusCode) {
            if (errorDisplay.statusCode === 401) {
                return "fa fa-lock";
            }
            if (errorDisplay.statusCode === 403) {
                return "fa fa-user-lock";
            }
        }
        return "fa fa-exclamation-triangle";
    };
    __decorate([
        observable.shallow,
        __metadata("design:type", Array)
    ], ErrorHandler.prototype, "errorList", void 0);
    __decorate([
        observable.ref,
        __metadata("design:type", Object)
    ], ErrorHandler.prototype, "hidingErrorList", void 0);
    return ErrorHandler;
}(Components.ErrorHandler));
export { ErrorHandler };
